import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FacilityDetailsPipe } from '../pipes/facility-details.pipe';
import { TranslatePipe } from '../pipes/translate.pipe';
import { AppointmentService } from '../services/appointment.service';
import { GoogleTagsService } from '../services/google-tags.service';
import { PackageService } from '../services/package.service';
import { PaymentService } from '../services/payment.service';
import { UserService } from '../services/user.service';
import { LinkPatientService } from '../services/link-patient.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-health-package-confirmation',
  templateUrl: './health-package-confirmation.component.html',
  styleUrls: ['./health-package-confirmation.component.scss']
})
export class HealthPackageConfirmationComponent {
  @Input() apptConfirmDetails: any;
  @Input() reqConfirm:any;
  @Input() healthPkg:any;
  @Output() close: EventEmitter<any>;
  @Output() action: EventEmitter<any>;
  @Output() switchAction: EventEmitter<any>;

  public paymentStatus: string;
  public paymentData: any;
  public isReqRecieved: boolean;
  public linkedPatient: any;
  public isBookingSubService: boolean = false;
  public pkgDetail: any;
  public groupedServices: any;
  constructor(private user: UserService, private apptService: AppointmentService, private paymentService:PaymentService, private translatePipe: TranslatePipe,private facilityPipe: FacilityDetailsPipe, private gtmService:GoogleTagsService, private cdf: ChangeDetectorRef, private packageService: PackageService, private linkPatient: LinkPatientService,  private router: Router) {
    this.close = new EventEmitter<any>();
    this.action = new EventEmitter<any>();
    this.switchAction = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.healthPkg = this.packageService.getAllHpValues()
    this.isBookingSubService = this.user?.getIsBookingSubService() || false;
    console.log('healthPkg in confirmation--', this.healthPkg, this.isBookingSubService, this.apptConfirmDetails, this.reqConfirm);
    if(this.isBookingSubService || this.healthPkg?.isBookingSubService) {
    this.pkgDetail = this.healthPkg?.requestInfo;
    this.groupedServices = this.healthPkg?.groupedServices;
    } else {
      this.isReqRecieved = this.apptConfirmDetails ? this.apptConfirmDetails['confirmReq'] : false;
      this.paymentStatus = this.apptConfirmDetails ? this.apptConfirmDetails['paymentStatus'] : null
      this.paymentData = this.apptConfirmDetails ? this.apptConfirmDetails['data'] : null
    this.user.getUserId().subscribe(data => {
        if (!data)
          return;
        this.linkPatient.getLinkedPatient(data).subscribe(result => {
          if (result.status === 'SUCCESS')
            var patientDetails = result?.['data']?.find(p => p['uhid'] == this.apptConfirmDetails?.patientId);
            this.apptConfirmDetails = {
              ...this.apptConfirmDetails,
              patientDetails: patientDetails
            }
        })
      });
    }
  }

  public closeModal() {
  this.packageService.clearAllValues();
  this.close.emit(true);
  }

  public switchActions(type){
    this.switchAction.emit(type);
  }

  public viewAppt() {
    // this.user.setIsFromPackage(true);
    // this.router.navigate([`${this.user.getPortalBasePath()}`])
    this.close.emit(true);
  }

  public goToPkgDetails() {
    // this.user.setIsFromPackage(true);
    this.user.setApptConfirmationDetails(this.apptConfirmDetails);
    // this.router.navigate([`${this.user.getPortalBasePath()}`])
    this.action.emit(this.apptConfirmDetails)
  }
}
